import type { Frequency, CalendarRow } from '../../../types/calendar';
import { ACTION_COLUMN_WIDTH, MIN_CELL_WIDTH } from '../../../config/calendarConstants';
export { formatPeriodLabel } from '../../../utils/formatPeriodLabel';

export function calculatePeriodColumnWidth(
    periodCount: number,
    frequency: Frequency,
    containerWidth: number,
    fixedColumnsWidth: number,
): number {
    const availableWidth = containerWidth - fixedColumnsWidth - ACTION_COLUMN_WIDTH;
    if (periodCount === 0) return MIN_CELL_WIDTH[frequency];
    const idealWidth = availableWidth / periodCount;
    return Math.max(idealWidth, MIN_CELL_WIDTH[frequency]);
}

export function getPromosForEvent(
    dataSource: CalendarRow[],
    eventId: string,
): { promo_id: string; promo_name: string }[] {
    const seen = new Set<string>();
    const promos: { promo_id: string; promo_name: string }[] = [];
    const collect = (row: CalendarRow) => {
        if (row.event_id === eventId && row.promo_id && !seen.has(row.promo_id)) {
            seen.add(row.promo_id);
            promos.push({ promo_id: row.promo_id, promo_name: row.promo_name ?? '' });
        }
    };
    for (const row of dataSource) {
        collect(row);
        if (row.children) {
            for (const child of row.children) {
                collect(child);
            }
        }
    }
    return promos;
}
